import {type FunctionalComponent, h} from '@stencil/core';
import type {SearchApiDocument} from '../../../../../api/SearchApi';
import type {Strategies} from '../../../../strategies/Strategies';
import type {IEolDiscontinuedDetails} from '../types/subcomponents-types.type';
import type {labelProviderInterface} from '../../../../LabelProviderInterface';

export interface EolDiscontinuedResultList {
  loading: boolean
  tabular: boolean
  mobileView: boolean
  isSubstitutionTool: boolean
  eolDiscontinuedResults: IEolDiscontinuedDetails;
  labelProvider: labelProviderInterface;
  tabName: string;
  strategies: Strategies;
  rtl: boolean;
  term: string;
  language: string;
  country: string;
}

export const EolDiscontinuedResultList: FunctionalComponent<EolDiscontinuedResultList> = (props) => {

    const {loading, tabular, mobileView, isSubstitutionTool, eolDiscontinuedResults, tabName, strategies, rtl, labelProvider, term, language, country} = props;

    const EolDocuments = () => {
        return eolDiscontinuedResults.documents?.length > 0
          ? eolDiscontinuedResults.documents.map((result: SearchApiDocument, index: number) => {
              return <uiaas-search-result-eol-discontinued
                doc={result}
                isDashboardView={false}
                index={index}
                strategies={strategies}
                replacementsTotalHits={eolDiscontinuedResults.replacementsTotalHits}
                labelProvider={labelProvider}
                rtl={rtl}
                term={term}
                language={language}
                country={country}
              />;
          })
          : null;
    };

    const EolDocumentsGroup = () => {
        return eolDiscontinuedResults.documentsGroup?.length > 0
          ? eolDiscontinuedResults.documentsGroup.map((result: SearchApiDocument, index: number) => {
              return <uiaas-search-result-eol-discontinued
                isEolDocumentsGroup={true}
                doc={result}
                isDashboardView={false}
                index={index}
                strategies={strategies}
                replacementsTotalHits={eolDiscontinuedResults.replacementsTotalHits}
                labelProvider={labelProvider}
                rtl={rtl}
                term={term}
                language={language}
                country={country}
              />;
          })
          : null;
    };

    return (
      !loading && !tabular && isSubstitutionTool && [<EolDocuments />, <EolDocumentsGroup />]
    );
};